/* eslint-disable prettier/prettier */
/**
 * TWPDFDocument - PDF document class
 */
class TWPdfDocument {
  constructor() {
    /**
     * @member {File} file - PDF file
     */
    this.documentFile = null;
    /**
     * @member {string} - PDF URL
     */
    this.documentUrl = "";
    /**
     * @member {string} - Document name
     */
    this.documentName = "";
    /**
     * @member {Array<TWPdfPage>} - Array of pages
     */
    this.pages = [];
    this.pagesSizeInfo = {
      maxWidth: 0,
      totalHeight: 0,
      numberOfBiggestPage: 0,
    };
  }

  resetTextLayer() {
    for (let i = 0; i < this.pages.length; i++) {
      this.pages[i].textLayer = null;
    }
  }
}

export { TWPdfDocument };
